import LocationGroup from "@app/types/map/LocationGroup";

const locationGeometryGetter = (
  locationGroup: LocationGroup
): Exclude<google.maps.Data.FeatureOptions["geometry"], undefined> => {
  return new google.maps.Data.Point({
    lat: locationGroup.locations[0].geoPoint.coordinates[1],
    lng: locationGroup.locations[0].geoPoint.coordinates[0],
  });
};

export default locationGeometryGetter;
